import { connect } from 'react-redux';
import { voteInPoll } from './redux/actionCreators';
import { canUserVoteInPoll } from './redux/selectors';
import { getIsMobile } from '../publicSession';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    return ({
        isMobile: getIsMobile(state),
        canVote: canUserVoteInPoll(state, deviation),
    });
};
var mapDispatchToProps = {
    onVote: voteInPoll,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=PollView.container.js.map